// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"HomepageBody_boxesContainer__3drLU","homeText":"HomepageBody_homeText__2znjR"};